export const UTENSILIOS_LOCK_REASON =
  'Obrigatório porque há café no pedido.';

export type PedidoNamesSnapshot = {
  products?: Record<number, string>;
  services?: Record<number, string>;
  carrinhoCoffeeLock?: Record<number, boolean>;
};

export function isUtensiliosServico(
  servicoId: number | undefined | null
): boolean {
  const id = Number(servicoId);
  return id === 4 || id === 5;
}

export function serviceNameMatchesUtensilios(name: string): boolean {
  const nome = (name || '').toLowerCase().trim();
  return (
    nome.includes('utensilio') ||
    nome.includes('utensílio') ||
    nome.includes('montagem')
  );
}

export function getCartServiceDisplayName(
  item: any,
  serviceNamesById?: Record<number, string>
): string {
  if (!item?.servicos_id) return '';
  const servicoId = Number(item.servicos_id);
  return (
    item._servico?.Nome ||
    item._servicos?.[0]?.Nome ||
    item._servicos?.Nome ||
    serviceNamesById?.[servicoId] ||
    item.nome ||
    item.name ||
    ''
  );
}

export function isUtensiliosCartItem(
  item: any,
  serviceNamesById?: Record<number, string>
): boolean {
  if (!item?.servicos_id) return false;
  if (isUtensiliosServico(item.servicos_id)) return true;
  return serviceNameMatchesUtensilios(
    getCartServiceDisplayName(item, serviceNamesById)
  );
}

export function productNameHasCoffee(name: string): boolean {
  const nome = (name || '').toLowerCase().trim();
  if (!nome) return false;
  if (nome.includes('café') || nome.includes('cafe')) return true;
  if (nome.includes('garrafa') && nome.includes('caf')) return true;
  return false;
}

export function productItemHasCoffee(
  item: any,
  productNamesById?: Record<number, string>
): boolean {
  if (!item?.produto_id) return false;

  const displayName = getCartProductDisplayName(item, productNamesById);
  if (productNameHasCoffee(displayName)) return true;

  const familia = String(
    item.familia ||
      item.Familia ||
      item._produto?.[0]?.Familia ||
      item._produto?.Familia ||
      ''
  ).toLowerCase();

  if (familia && productNameHasCoffee(familia)) return true;

  return false;
}

export function getCartProductDisplayName(
  item: any,
  productNamesById?: Record<number, string>
): string {
  if (!item?.produto_id) return '';
  return (
    item._produto?.[0]?.Nome ||
    item._produto?.Nome ||
    productNamesById?.[item.produto_id] ||
    item.nome ||
    item.name ||
    ''
  );
}

export function readPedidoNamesSnapshot(
  pedidoId?: number | null
): PedidoNamesSnapshot {
  if (!pedidoId || pedidoId <= 0) return {};

  try {
    const raw = localStorage.getItem(`pedidoNames_${pedidoId}`);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed as PedidoNamesSnapshot;
  } catch {
    return {};
  }
}

export function collectStoredProductNames(
  pedidoId?: number | null
): Record<number, string> {
  const names: Record<number, string> = {};

  const mergeProducts = (products?: Record<number, string>) => {
    if (!products || typeof products !== 'object') return;
    Object.entries(products).forEach(([id, name]) => {
      const productId = Number(id);
      if (!Number.isFinite(productId) || !name) return;
      names[productId] = String(name);
    });
  };

  mergeProducts(readPedidoNamesSnapshot(pedidoId).products);

  const selectedProductsKeys = [
    'selectedProducts_manual',
    localStorage.getItem('confirmedSuggestion')
      ? `selectedProducts_${localStorage.getItem('confirmedSuggestion')}`
      : null,
  ].filter(Boolean) as string[];

  for (const key of selectedProductsKeys) {
    try {
      const products = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(products)) continue;
      for (const product of products) {
        const productId = Number(product?.id ?? product?.produto_id);
        const productName = product?.name || product?.Nome || product?.nome;
        if (Number.isFinite(productId) && productName) {
          names[productId] = String(productName);
        }
      }
    } catch {
      // Ignorar chaves inválidas
    }
  }

  return names;
}

export function readCarrinhoCoffeeLockMap(
  pedidoId?: number | null
): Record<number, boolean> {
  return readPedidoNamesSnapshot(pedidoId).carrinhoCoffeeLock || {};
}

export function eventItemsHaveCoffee(
  eventItems: any[],
  productNamesById?: Record<number, string>
): boolean {
  return (eventItems || []).some(item => productItemHasCoffee(item, productNamesById));
}

export function isUtensiliosItemLockedByCoffee(
  item: any,
  eventItems: any[],
  productNamesById?: Record<number, string>,
  serviceNamesById?: Record<number, string>
): boolean {
  if (!isUtensiliosCartItem(item, serviceNamesById)) return false;
  return eventItemsHaveCoffee(eventItems, productNamesById);
}
